/*
  blog-gsd-calculator.js
  Ground sampling distance calculator for the drone mapping article.

  Geometry (rectilinear lens, nadir view, flat terrain):
    GSD [m/px]        = pixel_pitch [m] x altitude [m] / focal_length [m]
                      = (pitch_um x altitude_m) / (efl_mm x 1000)
    swath [m]         = GSD [m/px] x pixel_count
    required EFL [mm] = (pitch_um x altitude_m x 100) / target_GSD_cm...
      derived from GSD_cm = (pitch_um x altitude_m) / (efl_mm x 10)
      so efl_mm = (pitch_um x altitude_m) / (target_GSD_cm x 10)
    Johnson criteria (50% probability, good contrast): pixels across the
    target's critical dimension of ~2 (detect), ~8 (recognize), ~12.8 (identify).
    max altitude for N px on target: H = L_m x efl_mm x 1000 / (N x pitch_um)

  No dependencies. Runs only if the calculator markup exists on the page.
*/
(function () {
  'use strict';

  var root = document.getElementById('gsdcalc');
  if (!root) return;

  var SENSORS = {
    imx477: { pitch: 1.55, h: 4056, v: 3040 },
    imx283: { pitch: 2.4, h: 5496, v: 3672 },
    ar0521: { pitch: 2.2, h: 2592, v: 1944 },
    ar0234: { pitch: 3.0, h: 1920, v: 1200 },
    imx264: { pitch: 3.45, h: 2448, v: 2048 },
    imx462: { pitch: 2.9, h: 1920, v: 1080 }
  };

  var JOHNSON = [
    { label: 'Detect (something is there)', px: 2 },
    { label: 'Recognize (person vs vehicle)', px: 8 },
    { label: 'Identify (which vehicle type)', px: 12.8 }
  ];

  function $(id) { return document.getElementById(id); }

  var el = {
    preset: $('gsdcalc-preset'),
    pitch: $('gsdcalc-pitch'),
    pxh: $('gsdcalc-pxh'),
    pxv: $('gsdcalc-pxv'),
    efl: $('gsdcalc-efl'),
    alt: $('gsdcalc-alt'),
    target: $('gsdcalc-target'),
    targetGsd: $('gsdcalc-target-gsd'),
    gsd: $('gsdcalc-out-gsd'),
    swath: $('gsdcalc-out-swath'),
    reqEfl: $('gsdcalc-out-reqefl'),
    driBody: $('gsdcalc-dri-body'),
    results: $('gsdcalc-results'),
    dri: $('gsdcalc-dri'),
    invalid: $('gsdcalc-invalid')
  };

  function num(input) {
    var v = parseFloat(input.value);
    return (isFinite(v) && v > 0) ? v : null;
  }

  function fmt(value, digits) {
    if (!isFinite(value)) return '–';
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits
    });
  }

  function fmtRange(meters) {
    if (meters >= 1000) return fmt(meters / 1000, 2) + ' km';
    return fmt(meters, 0) + ' m';
  }

  function applyPreset() {
    var s = SENSORS[el.preset.value];
    if (!s) return;
    el.pitch.value = s.pitch;
    el.pxh.value = s.h;
    el.pxv.value = s.v;
  }

  function compute() {
    var pitch = num(el.pitch);
    var efl = num(el.efl);
    var alt = num(el.alt);
    var pxh = num(el.pxh);
    var pxv = num(el.pxv);
    var target = num(el.target);
    var targetGsd = num(el.targetGsd);

    var ok = pitch && efl && alt;
    el.invalid.hidden = !!ok;
    el.results.hidden = !ok;
    el.dri.hidden = !ok;
    if (!ok) return;

    var gsdM = (pitch * alt) / (efl * 1000);
    var gsdCm = gsdM * 100;

    el.gsd.textContent = fmt(gsdCm, gsdCm < 1 ? 2 : 1) + ' cm/px';

    if (pxh && pxv) {
      el.swath.textContent = fmt(gsdM * pxh, 0) + ' × ' + fmt(gsdM * pxv, 0) + ' m';
    } else {
      el.swath.textContent = 'enter pixel counts';
    }

    if (targetGsd) {
      el.reqEfl.textContent = fmt((pitch * alt) / (targetGsd * 10), 1) + ' mm';
    } else {
      el.reqEfl.textContent = '–';
    }

    var rows = '';
    if (target) {
      var pxOnTarget = target / gsdM;
      for (var i = 0; i < JOHNSON.length; i++) {
        var level = JOHNSON[i];
        var maxAlt = (target * efl * 1000) / (level.px * pitch);
        var met = pxOnTarget >= level.px;
        rows += '<tr><td>' + level.label + '</td>' +
          '<td class="clb-calc-num">' + fmt(level.px, 1) + ' px</td>' +
          '<td class="clb-calc-num">' + fmt(target / level.px * 100, 1) + ' cm/px</td>' +
          '<td class="clb-calc-num">' + fmtRange(maxAlt) + '</td>' +
          '<td>' + (met ? 'Yes, ' + fmt(pxOnTarget, 1) + ' px on target' : 'No, only ' + fmt(pxOnTarget, 1) + ' px') + '</td></tr>';
      }
    } else {
      rows = '<tr><td colspan="5">Enter an object size to evaluate detection levels.</td></tr>';
    }
    el.driBody.innerHTML = rows;
  }

  el.preset.addEventListener('change', function () {
    applyPreset();
    compute();
  });

  var inputs = [el.pitch, el.pxh, el.pxv, el.efl, el.alt, el.target, el.targetGsd];
  for (var i = 0; i < inputs.length; i++) {
    inputs[i].addEventListener('input', compute);
  }

  applyPreset();
  compute();
})();
